import React, { useState } from "react";
import "./Popular.css";
import Item from "../Item/Item";
import data from "../Assets/data";

const Popular = () => {
  // Group products by category for tabs
  const categories = {
    "medical": data.filter(item => 
      item.category === "medical" ||
      item.subCategory === "surgical-instruments"
    ),
    "lab": data.filter(item => 
      item.category === "lab"
    ),
    "chemical": data.filter(item => 
      item.category === "chemical" || 
      item.category === "reagent"
    )
  };

  // Set initial tab to the first available category
  const [activeTab, setActiveTab] = useState(Object.keys(categories)[0] || "medical");

  // Get the current category items or empty array if undefined
  const currentItems = categories[activeTab] || [];

  return (
    <div className="popular">
      <div className="popular-header">
        <h2>Most Requested Medical Supplies</h2>
        <p>Trusted by hospitals, labs, and research facilities worldwide</p>
        
        <div className="category-tabs">
          {Object.keys(categories).map(category => (
            <button
              key={category}
              className={`tab-btn ${activeTab === category ? 'active' : ''}`}
              onClick={() => setActiveTab(category)}
            > 
              {category.charAt(0).toUpperCase() + category.slice(1)}
            </button>
          ))}
        </div>
      </div>

      <div className="popular-items">
        {currentItems.length > 0 ? (
          currentItems.slice(0, 4).map((item) => (
            <Item 
              key={item.id}
              id={item.id}
              name={item.name} 
              image={item.image} 
              new_price={item.new_price} 
              old_price={item.old_price}
            />
          ))
        ) : (
          <p className="no-items">No items found in this category</p>
        )}
      </div>

      {currentItems.length > 0 && (
        <div className="view-all">
          <button className="view-all-btn">
            View All {activeTab}
            <span className="arrow">→</span>
          </button>
        </div>
      )}
    </div>
  );
}

export default Popular;